import React, { createContext, useState, useMemo, useCallback } from "react";

export const UserReportContext = createContext();

export const UserReportProvider = ({ children }) => {
  const [labels, setLabels] = useState([]);
  const [material, setMaterial] = useState([]);
  const [assignment, setAssignment] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [learnerList, setLearnerList] = useState([]);
  const [showPage, setShowPage] = useState("profile");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [userTimeSpentDetails, setUserTimeSpentDetails] = useState([]);
  const [userTimeSpentTableData, setUserTimeSpentTableData] = useState([]);
  const [userTestResultTableData, setUserTestResultTableData] = useState([]);

  const [userTimeSpentModuleData, setUserTimeSpentModuleData] = useState({
    lpIds: "",
    moduleIds: "",
  });

  const [currentLearnerDetails, setCurrentLearnerDetails] = useState({
    value: 0,
    label: "",
  });

  const [userTimeSpentModuleOption, setUserTimeSpentModuleOption] = useState(
    []
  );

  const currentIndex = useMemo(() => {
    return learnerList.findIndex(
      (learner) => learner.value === currentLearnerDetails.value
    );
  }, [learnerList, currentLearnerDetails.value]);

  const setCurrentIndex = useCallback((index) => {
    if (learnerList[index]) {
      setCurrentLearnerDetails(learnerList[index]);
    }
  }, [learnerList]);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      labels,
      showPage,
      material,
      setLabels,
      assignment,
      assessment,
      learnerList,
      setMaterial,
      setShowPage,
      currentIndex,
      setAssignment,
      setAssessment,
      selectedMonth,
      setLearnerList,
      setCurrentIndex,
      setSelectedMonth,
      userTimeSpentDetails,
      currentLearnerDetails,
      userTimeSpentTableData,
      setUserTimeSpentDetails,
      userTestResultTableData,
      userTimeSpentModuleData,
      setCurrentLearnerDetails,
      userTimeSpentModuleOption,
      setUserTimeSpentTableData,
      setUserTestResultTableData,
      setUserTimeSpentModuleData,
      setUserTimeSpentModuleOption,
    }),
    [
      labels,
      showPage,
      material,
      assignment,
      assessment,
      learnerList,
      currentIndex,
      setCurrentIndex,
      selectedMonth,
      userTimeSpentDetails,
      currentLearnerDetails,
      userTimeSpentTableData,
      userTestResultTableData,
      userTimeSpentModuleData,
      userTimeSpentModuleOption,
    ]
  );

  return (
    <UserReportContext.Provider value={contextValue}>
      {children}
    </UserReportContext.Provider>
  );
};
